import { subDays } from "date-fns";
import axios from "axios";
import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import { SME_WEB_BASE_URL, WEB_BASE_URL } from "../../unified/webbase";
import cookie from "react-cookies";
import { CSVLink } from "react-csv";
import Multiselect from 'multiselect-react-dropdown';

class TransactionBucket extends React.Component {
    constructor() {
        super();
        this.state = {
            token: cookie.load("token"),
            userRole: cookie.load("userRole"),
            userGroup: cookie.load("userGroup"),
            walletBalance: cookie.load("walletBalance"),
            selectedTable: "Monthly",
            startDate: new Date(),
            endDate: new Date(),
            fromDate: this.makeShortDate(new Date()),
            toDate: this.makeShortDate(new Date()),
            transactions: [],
            filterValue: '',
            merchantEmail:'',
            walletHistory: [],
            dataByDate: {},
            isLoading: false,
            network: [
                { id: 1, name: "MTN" },
                { id: 2, name: "Glo" },
                { id: 3, name: "9mobile" },
                { id: 4, name: "Airtel" },
            ],
            filterOptions: [
                { id: 1, name: "Network" },
                // { id: 2, name: "MSISDN" },
                { id: 3, name: "Beneficiary No" },
                { id: 4, name: "Merchant ID" },
                { id: 5, name: "Customer Reference" }
            ],
            selectedFilters: [],
            marchantList:[],
            msisdn: "",
            beneficiaryPhone: "",
            customerReference: "",
            selectedNetwork: "",
            merchantId: "",
            status: "",
            apiPage: 1,
            subPage: 1,
            apiLimit: 500,
            subPageSize: 100,
        };
        
        if (this.state.userGroup == "MERCHANT") {

            this.state.filterOptions = [
                { id: 1, name: "Network" },
                { id: 2, name: "MSISDN" },
                { id: 3, name: "Beneficiary No" },
                { id: 4, name: "Merchant ID" },
                { id: 5, name: "Customer Reference" },
                { id: 6, name: "Mobile App" }
            ]
        }
        this.setState({})
        //binding this to event-handler functions
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        this.getTransactions = this.getTransactions.bind(this);
        this.getDailyTransactions = this.getDailyTransactions.bind(this);
        this.getWeeklyTransactions = this.getWeeklyTransactions.bind(this);
        this.getCustomReport = this.getCustomReport.bind(this);
        this.getWalletBalance = this.getWalletBalance.bind(this);
        this.reduceTransactions = this.reduceTransactions.bind(this);
        this.onSelectFilter = this.onSelectFilter.bind(this);
        this.onRemoveFilter = this.onRemoveFilter.bind(this);
        this.makeShortDate = this.makeShortDate.bind(this);
        this.getMerchant = this.getMerchant.bind(this);
    }

    onSelectFilter(selectedList, selectedItem) {
        this.setState({
            selectedFilters: selectedList
        })
    }

    onRemoveFilter(selectedList, removedItem) {
        this.setState({
            selectedFilters: selectedList
        })
    }
    makeShortDate(datew) {
        datew = new Date(datew);
        let yy = datew.getFullYear();
        let mm = datew.getMonth();
        let dd = datew.getDate();
        let shortDate = `${yy}-${mm < 10 ? 0 : ""}${mm + 1}-${dd < 10 ? 0 : ""
            }${dd}`;
        return shortDate;
    }

    setStartDate(date) {
        let datew = this.makeShortDate(date);

        this.setState({
            startDate: date,
            fromDate: datew,
        });
    }

    setEndDate(date) {
        let datew = this.makeShortDate(date);

        this.setState({
            endDate: date,
            toDate: datew,
        });
    }

    getTransactions = () => {
        let api = "";
        if (this.state.userGroup == "MERCHANT") {
            api = "/merchant/merchant-monthly-report";
        } else {
            api = "/dealer/dealer-monthly-report";
        }
        axios
            .get(WEB_BASE_URL + api, {
                headers: {
                    authorization: this.state.token,
                },
            })
            .then((res) => {
                if (res.data.description === "No data available") {

                } else {
                    const trans = res.data.data.data;
                    this.setState({ transactions: trans });
                }
            })
            .catch((err) => {
                toast.error("Error fetching transactions");
            });
    };

    getCustomReport() {
        this.setState({
            isLoading: true
        })
        let api = "";
        if (this.state.userGroup == "MERCHANT") {
            api = "/merchant/merchant-custom-report";
        } else {
            if(this.state.selectedNetwork !== ""){
                api = "/dealer/dealer-custom-report"
               
            }else if(this.state.merchantEmail !== ""){
                api = "/dealer/report-by-merchant";
            }
            else{
                api = "/dealer/report-by-merchant";
            }
           
        }
        let paginationParams = "";
        if (api === "/dealer/dealer-custom-report") {
            paginationParams = `&limit=${this.state.apiLimit}&page=${this.state.apiPage}`;
        } else if (api === "/dealer/report-by-merchant") {
            paginationParams = `&size=${this.state.apiLimit}&page=${this.state.apiPage}`;
        } else {
            // Default or other APIs
            paginationParams = "&offSet=0&page=50000";
        }

        axios
            .get(
                WEB_BASE_URL +
                api + "?startDate=" +
                this.state.fromDate.split('/').join('-') +
                "&endDate=" +
                this.state.fromDate.split('/').join('-') + "&statusCode=" + this.state.status + "&beneficiaryPhone=" + this.state.beneficiaryPhone
                + paginationParams + "&customerRef=" + this.state.customerReference +
                "&msisdn=" + this.state.msisdn +
                "&networkId=" + this.state.selectedNetwork + "&merchantId=" + this.state.merchantId + "&merchantEmail=" + this.state.merchantEmail,
                {
                    headers: {
                        authorization: this.state.token,
                    },
                }
            )
            .then((res) => {
                if (res.data.status === "2000" && res.data.data !== null) {
                    this.setState({ 
                        transactions: res.data.data,
                        subPage: 1 // Reset subpage on new fetch
                    });
                } else {
                    toast.error(res.data.description);
                    this.setState({ transactions: [] });
                }
            })
            .catch((err) => {
                console.log(WEB_BASE_URL + " " + err);
                toast.error("Error fetching transactions");
            }).finally(() => {
                this.setState({
                    isLoading: false
                })
            });
    }

    getDailyTransactions = () => {
        let api = "";
        const today = new Date();
        let datee = this.makeShortDate(today);
        let yesterday = new Date(today);
        yesterday = this.makeShortDate(yesterday.setDate(today.getDate() - 1))
        

        axios
            .get(SME_WEB_BASE_URL
                 + '/glowsme/custom-report' + 
                 "?startDate=" +
                 this.makeShortDate(this.state.startDate) +
                "&endDate=" +
                this.makeShortDate(this.state.endDate) + "&phoneNumber=", {
                headers: {
                    authorization: this.state.token,
                },
            })
            .then((res) => {
                if (res.data.status == "4000") {
                    toast.error(res.data.description);
                }
                else {
                    const trans = res.data.data;
                    // const filteredTransactions = trans.filter(transaction => 
                    //     (transaction.customerReference + transaction.requestType + transaction?.beneficiary).includes(this.state.filterValue)
                    // );
                    this.setState({transactions: trans });
                    
                }
            })
            .catch((err) => {
                toast.error("Error fetching transactions");
                console.log(err)
            });
    };
    

    getWeeklyTransactions = () => {
        let api = "";

        if (this.state.userGroup == "MERCHANT") {
            api = "/merchant/merchant-weekly-report";
        } else {
            api = "/dealer/dealer-weekly-report";
        }

        axios
            .get(WEB_BASE_URL + api, {
                headers: {
                    authorization: this.state.token,
                },
            })
            .then((res) => {
                if (res.data.description === "No data available") {
                }
                else {
                    const trans = res.data.data.data;
                    this.setState({ transactions: trans });
                    this.reduceTransactions(trans);
                }
            })
            .catch((err) => {
                toast.error("Error fetching transactions");
            });
    };


    getWalletBalance() {
        axios
            .get(WEB_BASE_URL + "/onboarding/account-balance", {
                headers: {
                    authorization: this.state.token,
                },
            })
            .then((res) => {
                cookie.save("walletBalance", res.data.data.entBalance, {
                    path: "/",
                    expires: new Date(Date.now() + 60 * 30 * 1000),
                });

                this.setState({ walletBalance: res.data.data.entBalance ? res.data.data.entBalance : 0 });
            })
            .catch((err) => { console.log(WEB_BASE_URL + " " + err); })
    }

    getMerchant() {
        axios
            .post(WEB_BASE_URL + "/onboarding/all-merchants", {},{
                headers: {
                    authorization: this.state.token,
                },
            })
            .then((res) => {

                this.setState({ marchantList: res.data.data.data });
            })
            .catch((err) => { console.log(WEB_BASE_URL + " " + err); })
    }

    reduceTransactions(transactions) {
        const dataByDate = transactions.reduce((accumulator, transaction) => {
            const date = transaction.requestDate.split("T")[0];
            const amount = transaction.amount;
            if (!accumulator[date]) {
                accumulator[date] = 0;
            }
            accumulator[date] += amount;
            return accumulator;
        }, {});
        this.setState({ dataByDate });
    }
    handleInputChange = (event) => {
        const { value } = event.target;
        this.setState({ filterValue: value }, () => {
            this.getDailyTransactions(); // Call API again after state update
        });
    };
    componentDidMount() {
        this.getDailyTransactions();
        this.getWalletBalance();
        this.getMerchant();
    }
    handleSelectChange = (event) => {
        const selectedBusinessEmail = event.target.value;
          this.setState({
            merchantEmail: selectedBusinessEmail
          });
      };
      getLast20Chars = (str) => {
        if (!str) {
          return '';
        }
        if (str.length <= 40) {
          return str;
        }
        return str.slice(-40);
      }
      componentDidUpdate(prevProps, prevState) {
        if ( prevState.startDate !== this.state.startDate || prevState.endDate !== this.state.endDate  ) {
          this.getDailyTransactions();
        }
      }
    render() {
        var formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "NGN",
        });

        const { subPage, subPageSize, transactions, userGroup } = this.state;
        let transactionsToDisplay = userGroup === "MERCHANT" 
            ? transactions 
            : transactions.slice((subPage - 1) * subPageSize, subPage * subPageSize);
        return (
            <main className="page-content">
                <ToastContainer
                    position="top-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                    <div className="ps-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:;">
                                        <i className="bx bx-home-alt"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                Bucket Transaction  
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="ms-auto">
                        <div className="btn-group">
                            <button type="button" className="btn btn-primary">
                                Wallet Balance: &#8358;{this.state.walletBalance}
                            </button>
                        </div>
                    </div>
                </div>
 
                <div className="card">
                    <div className="card-body">
                        <form className="row">
                            <div className="row">
                                <div className="col-3">
                                    <label className="form-label">Start date:</label>
                                    <DatePicker
                                        selected={this.state.startDate}
                    minDate={subDays(new Date(), 60)}
                    maxDate={this.state.endDate}
                                        onSelect={(date) => this.setStartDate(date)}
                                        onChange={(date) => this.setStartDate(date)}
                                        maxDate={new Date()}
                                    />
                                </div>
                                <div className="col-3">
                                    <label className="form-label">End Date:</label>
                                    <DatePicker
                                        selected={this.state.startDate}
                    minDate={subDays(new Date(), 60)}
                    maxDate={this.state.endDate}
                                        onSelect={(date) => this.setEndDate(date)}
                                        onChange={(date) => this.setEndDate(date)}
                                        maxDate={new Date()}
                                    />
                                </div>
                                
                               
                            
                                <div className="col-3">
                                    <label className="form-label">Filter</label>
                                    <Multiselect
                                        options={this.state.filterOptions} // Options to display in the dropdown
                                        selectedValues={this.state.selectedFilters} // Preselected value to persist in dropdown
                                        onSelect={this.onSelectFilter} // Function will trigger on select event
                                        onRemove={this.onRemoveFilter} // Function will trigger on remove event
                                        displayValue="name" // Property name to display in the dropdown options
                                        style={{
                                            chips: {
                                                borderRadius: "3px",
                                                backgroundColor: "#6c757d",
                                            }
                                        }}
                                        customCloseIcon={
                                            <i className="bi bi-x-circle-fill" style={{
                                                position: "absolute",
                                                right: "10px",
                                                top: "12px"
                                            }}></i>
                                        }
                                    />
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header py-3">
                        <div className="row g-3">
                            
                            <div className="col-lg-6 col-md-6 me-auto">
                                <div className="ms-auto position-relative">
                                    <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                        <i className="bi bi-search"></i>
                                    </div>
                                    <input
                                        className="form-control ps-5"
                                        type="text"
                                        value={this.state.filterValue}
                                        onChange={this.handleInputChange}
                                        placeholder="Search by customer reference, type and beneficiary "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table className="table align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Product</th>
                                    
                                        <th>Email Address</th>
                                        <th>Customer Ref</th>
                                        <th>Phone</th>
                                        <th>Refund status</th>
                                        <th>Date</th>
                                        <th>Message</th>
                                        <th>Status code</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactionsToDisplay.length !== 0 ? (
                                        transactionsToDisplay.map((voucher, index) => (
                                            <tr key={index}>
                                                <td>{voucher?.product}</td>
                                                <td>{voucher?.emailAddress}</td>
                                                <td>{voucher?.customerRef}</td>
                                                <td>{voucher?.beneficiaryPhone}</td>
                                                <td>{voucher?.refundStatus}</td>
                                                
                                                <td>
                                                    {voucher.transactionDate !== undefined
                                                        ? new Date(voucher.transactionDate).toLocaleString()
                                                        : 0}
                                                </td>
                                                <td>{voucher.message}</td>
                                               
                                                <td>{voucher.statusCode}</td>
                                                <td>{voucher.status}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr colSpan="7">
                                            <td>No Transaction Record.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {this.state.userGroup !== "MERCHANT" && (
                            <div style={{
                                overflowX: "scroll",
                            }}>
                                <nav class="float-end mt-3">
                                    <ul className="pagination">
                                        <li className={`page-item ${this.state.apiPage === 1 && this.state.subPage === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" onClick={() => {
                                                if (this.state.subPage > 1) {
                                                    this.setState({ subPage: this.state.subPage - 1 });
                                                } else if (this.state.apiPage > 1) {
                                                    this.setState({ apiPage: this.state.apiPage - 1, subPage: 5 }, () => this.getCustomReport());
                                                }
                                            }}>
                                                {"<"}
                                            </button>
                                        </li>
                                        <li className="page-item disabled">
                                            <span className="page-link">
                                                Page: {(this.state.apiPage - 1) * 5 + this.state.subPage}
                                            </span>
                                        </li>
                                        <li className={`page-item ${this.state.transactions.length < (this.state.subPage * this.state.subPageSize) ? 'disabled' : ''}`}>
                                            <button className="page-link" title="Next 100 (Cache)" onClick={() => {
                                                if (this.state.subPage < 5 && this.state.transactions.length > (this.state.subPage * this.state.subPageSize)) {
                                                    this.setState({ subPage: this.state.subPage + 1 });
                                                }
                                            }}>
                                                {">"}
                                            </button>
                                        </li>
                                        <li className="page-item">
                                            <button className="page-link" title="Next 500 (API)" onClick={() => {
                                                this.setState({ apiPage: this.state.apiPage + 1, subPage: 1 }, () => this.getCustomReport());
                                            }}>
                                                {">>"}
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        )}
                    </div>
                </div>
            </main >
        );
    }
}

export default TransactionBucket;
